module.exports = __webpack_public_path__ + "static/media/imagem31.6dc5b12c.jpeg";